// ClosetDetail.jsx
// お気に入りクローゼット: 1着のカルテ（写真・AI判定・お手入れ履歴）と、品目の選び直し・削除（2026-09-24）。
// 写真は API が RFDB から中継する署名付きURL（1時間で失効）。RFDB に届かないときは控え（サムネイル・品目）だけ出す。
import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Post } from '../compornents/Post';
import { toast } from 'react-toastify';
import { useModal } from 'react-hooks-use-modal';
import { TailSpin } from 'react-loading-icons';
import { Analytics } from '../compornents/Analytics';
import { EVENT_LABEL, PHOTO_LABEL } from '../compornents/closetImage';
import { ItemPicker, ClosetToolbar } from './Closet';

const Row = ({ label, children }) => (
  <div style={{ display: 'flex', gap: 10, fontSize: 13, padding: '6px 0', borderBottom: '1px solid #f0f0f0' }}>
    <div style={{ width: 84, color: '#666', flex: '0 0 auto' }}>{label}</div>
    <div style={{ flex: 1 }}>{children}</div>
  </div>
);

export const ClosetDetail = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [d, setD] = useState(null);
  const [itemKeys, setItemKeys] = useState([]);
  const [editing, setEditing] = useState(false);
  const [zoom, setZoom] = useState('');
  const [ConfirmModal, openConfirm, closeConfirm] = useModal('root', {});

  const load = async () => {
    const [r, idx] = await Promise.all([
      Post('post', '/closet/detail.php', { id }),
      Post('post', '/closet/index.php', {}),
    ]);
    if (!r || r.result !== 1) { toast.error('見つかりませんでした'); navigate('/closet'); return; }
    setD(r);
    setItemKeys((idx && idx.item_keys) || []);
  };
  useEffect(() => {
    setTimeout(() => window.scrollTo(0, 0), 10);
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const changeItem = async (key) => {
    const r = await Post('post', '/closet/set_item.php', { id, item_key: key });
    if (r && r.result === 1) { setEditing(false); toast.success('品目を変更しました'); load(); }
    else toast.error('変更できませんでした');
  };

  const remove = async () => {
    closeConfirm();
    const r = await Post('post', '/closet/delete.php', { id });
    if (r && r.result === 1) { toast.success('クローゼットから削除しました'); navigate('/closet'); }
    else toast.error('削除できませんでした');
  };

  if (!d) return <div className="App"><div className="Address"><ClosetToolbar title="服のカルテ" onBack={() => navigate('/closet')} /><div className="m-4"><TailSpin stroke="#000" /></div></div></div>;

  const it = d.item;
  const ai = d.ai || {};
  const photos = d.photos || [];
  const material = (ai.material || []).map((m) => (m.percent ? `${m.fiber} ${m.percent}%` : m.fiber)).join('・');
  const care = (ai.care_symbols || []).join(' ／ ');

  return (
    <div className="App">
      <div className="Address">
        <Analytics title="クローゼット_カルテ" />
        <ClosetToolbar title={it.item_label || '服のカルテ'} onBack={() => navigate('/closet')} />
        <div className="m-4 mb-5 text-left">

          <div style={{ display: 'flex', gap: 8, overflowX: 'auto', paddingBottom: 6 }}>
            {photos.length > 0 ? photos.map((p) => (
              <div key={p.url} style={{ flex: '0 0 auto', textAlign: 'center' }}>
                <img src={p.url} alt="" className="div_btn" onClick={() => setZoom(p.url)}
                  style={{ width: 120, height: 120, objectFit: 'cover', borderRadius: 10, border: '1px solid #ddd' }} />
                <div style={{ fontSize: 11, color: '#666' }}>{PHOTO_LABEL[p.kind] || p.kind}</div>
              </div>
            )) : it.thumb_url ? (
              <img src={it.thumb_url} alt="" style={{ width: 120, height: 120, objectFit: 'cover', borderRadius: 10, border: '1px solid #ddd' }} />
            ) : null}
          </div>
          {Number(d.rfdb_available) !== 1 && <div style={{ fontSize: 12, color: '#b45309', marginTop: 4 }}>いま写真と履歴を読み込めません。時間をおいて開き直してください。</div>}

          <div style={{ marginTop: 12 }}>
            <Row label="品目">
              {it.item_label || '未選択'}
              {it.item_key_source === 'ai' && <span style={{ fontSize: 11, color: '#666', marginLeft: 6 }}>（AIの判定）</span>}
              <span className="div_btn" onClick={() => setEditing(!editing)} style={{ color: '#1d4ed8', marginLeft: 10, fontSize: 12 }}>{editing ? 'やめる' : '選び直す'}</span>
            </Row>
            {editing && <div style={{ padding: '10px 0' }}><ItemPicker itemKeys={itemKeys} value={it.item_key} onChange={changeItem} /></div>}
            {it.item_name && <Row label="メモ">{it.item_name}</Row>}
            {ai.color && <Row label="色・柄">{[ai.color, ai.color_sub, ai.pattern].filter(Boolean).join('・')}</Row>}
            {ai.brand && <Row label="ブランド">{ai.brand}</Row>}
            {material && <Row label="素材">{material}</Row>}
            {care && <Row label="洗濯表示">{care}</Row>}
            <Row label="登録日">{String(it.insert_day || '').slice(0, 10)}</Row>
            {it.code && <Row label="衣類ID">{it.code}</Row>}
          </div>

          <div style={{ fontWeight: 700, fontSize: 14, margin: '18px 0 6px' }}>お手入れの履歴</div>
          {(d.events || []).length === 0 ? <div style={{ fontSize: 13, color: '#666' }}>まだ履歴はありません。</div> : (
            <div>
              {d.events.map((e, i) => (
                <div key={i} style={{ borderLeft: '3px solid #15803d', padding: '4px 0 8px 10px', marginBottom: 6 }}>
                  <div style={{ fontSize: 12, color: '#666' }}>{String(e.created_at || '').slice(0, 10)}{e.shop_name ? `　${e.shop_name}` : ''}</div>
                  <div style={{ fontSize: 14, fontWeight: 700 }}>{EVENT_LABEL[e.kind] || e.kind}</div>
                  {e.note && <div style={{ fontSize: 13 }}>{e.note}</div>}
                  {e.photo_url && <img src={e.photo_url} alt="" className="div_btn" onClick={() => setZoom(e.photo_url)} style={{ width: 90, height: 90, objectFit: 'cover', borderRadius: 6, marginTop: 4 }} />}
                </div>
              ))}
            </div>
          )}

          <div className="div_btn" onClick={openConfirm} style={{ color: '#dc2626', fontSize: 13, marginTop: 24, textAlign: 'center' }}>クローゼットから削除する</div>
        </div>

        {zoom && (
          <div onClick={() => setZoom('')} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.85)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 12 }}>
            <img src={zoom} alt="" style={{ maxWidth: '100%', maxHeight: '100%' }} />
          </div>
        )}
        <ConfirmModal>
          <div className="modal rounded text-center pb-4 pl-4 pr-4 m-1" style={{ background: '#fff' }}>
            <div style={{ fontWeight: 700, margin: '12px 0 6px' }}>この服を削除しますか？</div>
            <div style={{ fontSize: 13, color: '#666', marginBottom: 12 }}>写真とお手入れの履歴も削除され、元に戻せません。</div>
            <div style={{ display: 'flex', gap: 8, justifyContent: 'center' }}>
              <button className="btn btn-outline-secondary" onClick={closeConfirm}>やめる</button>
              <button className="btn btn-danger" onClick={remove}>削除する</button>
            </div>
          </div>
        </ConfirmModal>
      </div>
    </div>
  );
};
